import { render, staticRenderFns } from "./VaIconVuestic.vue?vue&type=template&id=22524ad3&"
import script from "./VaIconVuestic.vue?vue&type=script&lang=js&"
export * from "./VaIconVuestic.vue?vue&type=script&lang=js&"
import style0 from "./VaIconVuestic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports